module.exports = {"addButtonText":"Generate","settingType":"Setting Type","wafRuleList":"Whitelist","isEnabled":"Enable","editWafRule":"Edit Whitelist","addWafRule":"Add Whitelist","reachMaxWafRuleListLength":"You can only add up to {maxWafRuleListLength} whitelist","wafRuleModalFormValidationError":"Please complete the form","addText":"Add Condition","collapseText":"Collapse","wafRule":{"name":{"label":"Name","placeholder":"Whitelist Name"},"isEnabled":{"label":"Enable"},"rules":{"label":"Rules","rule":{"type":"Type","name":"Name","isPositive":"Match"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/intelligentProtectionSettings.json
// module id = 5Jbr
// module chunks = 3